import styled from 'styled-components';

import { H1styles, H2styles } from '~/src/common/components/Typography';
import { getMediaQuery } from '~/src/common/utils/style';
import { CATALOG_SIDE_PADDING } from '~/src/screens/App/CatalogLayout/layout';
import { breakpoints, zIndex } from '~/src/styles-constants';

import { STICKY_DESKTOP, STICKY_MOBILE } from '../constants';

const AREA_HEAD = 'head';
const AREA_SIDE = 'side';
const AREA_BODY = 'body';

export const Container = styled.div`
  display: grid;
  margin: 16px 0 32px;
  grid-template:
    '${AREA_HEAD} ${AREA_HEAD}' auto
    '${AREA_SIDE} ${AREA_BODY}' 1fr
    / 288px 1fr;

  @media ${getMediaQuery(0, breakpoints.XL)} {
    margin: 0 0 32px;
    grid-template:
      '${AREA_SIDE}' auto
      '${AREA_HEAD}' auto
      '${AREA_BODY}' 1fr
      / 1fr;
  }
`;

export const Head = styled.div`
  grid-area: ${AREA_HEAD};
  margin: 0 0 16px;

  &:empty {
    display: none;
  }
`;

export const Side = styled.aside`
  grid-area: ${AREA_SIDE};
  align-self: flex-start;
  margin: 0 32px 0 0;
  padding: 0 0 32px;

  position: sticky;
  top: ${STICKY_DESKTOP}px;

  overflow: auto;
  max-height: calc(100vh - ${STICKY_DESKTOP}px);

  @media ${getMediaQuery(0, breakpoints.XL)} {
    top: ${STICKY_MOBILE}px;
    z-index: ${zIndex.familiesMenu};
    margin: 0 -${CATALOG_SIDE_PADDING}px 16px;
    padding: 0;
  }
`;

export const Body = styled.main`
  grid-area: ${AREA_BODY};

  header {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 12px;

    h1 {
      ${H1styles};
      margin: 0 0 16px;
      padding: 0;
    }

    h2 {
      ${H2styles};
      margin: 0 0 16px;
      padding: 0;
    }

    span {
      translate: 0 -8px;
    }

    a {
      color: inherit;
    }
  }

  summary {
    margin: 0 0 16px;

    &::marker {
      content: none;
      display: none;
    }

    p:only-child {
      margin: 0;
      padding: 0;
    }
  }

  footer {
    margin: 0;
  }
`;
